import { CreditNoteFilters, Paginated, Sortable } from "@ac-expo/api-types";

export const creditNotesQueryKeys = {
  all: ["creditNotes"] as const,
  lists: (filters: Sortable<Paginated<CreditNoteFilters>> | undefined) =>
    [...creditNotesQueryKeys.all, filters] as const,
  acExpo: {
    all: ["creditNotes", "acExpo"] as const,
    orderItems: (orderId?: string) =>
      ["creditNotes", "acExpo", "orderItems", orderId] as const,
  },
};

export default creditNotesQueryKeys;
